import BidAndFollowersBlock from './bid-and-followers-block';
export default BidAndFollowersBlock;